import { arTN } from "../../../../date-fns/locale/ar-TN.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    arTN
  }
};